export default {
  name: "Rental",
  data() {
    return {
      coverList: [
        {
          cover:
            "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/58442935_10157137832064450_6508413098976608256_n.jpg?_nc_cat=101&_nc_ht=scontent-sjc3-1.xx&oh=8470da7c6f2826832991d2a7c266aa0b&oe=5D3DC88D",
          title: "Angular"
        },
        {
          cover:
            "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/58444600_10157137832184450_3312656864646266880_n.jpg?_nc_cat=102&_nc_ht=scontent-sjc3-1.xx&oh=55f39a62b35dabaf91ba63b44342a45a&oe=5D718A99",
          title: "Vue"
        },
        {
          cover:
            "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/58542787_10157137832214450_810522786169618432_n.jpg?_nc_cat=106&_nc_ht=scontent-sjc3-1.xx&oh=69757ccfeeae54aaeda76a272fcebc19&oe=5D2EAFB7",
          title: "Webpack"
        },
        {
          cover:
            "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/58375244_10157137832304450_3416748931822911488_n.jpg?_nc_cat=102&_nc_ht=scontent-sjc3-1.xx&oh=edbf9bb2cc667a0bef262f0053717d91&oe=5D6ACA42",
          title: "Yarn"
        },
        {
          cover:
            "https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-9/57614883_10157137832324450_6266814054635929600_n.jpg?_nc_cat=100&_nc_ht=scontent-sjc3-1.xx&oh=9ac10e6ea59024eb7777326d8effec6d&oe=5D2B9380",
          title: "Node"
        }
      ]
    };
  },
  methods: {
    apply() {
      window.open("https://forms.gle/jqnePa1KMmB5U3Hj7", "_blank");
    }
  }
};
